
import {Component, Vue, Inject, Prop, Watch} from "vue-property-decorator";
import api from "@/api";


@Component({
  name: "SidebarLogo"
})
export default class SidebarLogo extends Vue {

  get collapse(): boolean {
    return this.$store.getters['app/sidebarOpened']

  }


  get title() {
    return this.$store.getters['user/ou'].displayName
  }

  get logo() {
    return this.$store.getters['user/ou'].detail.logoImgUrl;
  }

  get fu(){
    return this.$store.getters['app']
  }

  created() {
  }
}
